    <form
      *ngIf="service.form"
      [formGroup]="service.form"
      id="galileu-credential"
      (ngSubmit)="service.submitForm()"
      validateOnSubmit
    >
            <div class="fade-in-top">
              <div class="mb-3">
                <label class="form-label" for="galileu-credential-login">
                  {{ '::Login Galileu' | abpLocalization }} *
                </label>

                <input
                  id="galileu-credential-login"
                  formControlName="login"
                  class="form-control"
                  autofocus
                />
              </div>



              <div class="mb-3" *ngIf="podeGerir">
                <label class="form-label" for="galileu-credential-senha">
                  {{ '::Senha Galileu' | abpLocalization }} *
                </label>

                <div style="position: relative;">
                <input [abpShowPassword]="showPassword" id="galileu-credential-senha" formControlName="senha" class="form-control" />
                <i style="top: 15px" aria-label="Mostrar senha" (click)="showPassword = !showPassword" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'" toggle="#password-field" class=" show-pass-icon toggle-password"></i>
              </div>
              </div>

              <p class="text-muted mb-3" *ngIf="!podeGerir">
                A credencial do Galileu é única da transportadora. Só o administrador pode trocar ou limpar a senha.
              </p>
            </div>

      <!--<suite-custom-code-block-6>-->
      <!--</suite-custom-code-block-6>-->
    </form>
    <!--<suite-custom-code-block-8>-->
    <!--</suite-custom-code-block-8>-->
    <div class="d-flex justify-content-between" *ngIf="podeGerir">
      <abp-button buttonType="submit" formName="galileu-credential">
        {{ 'AbpUi::Sincronizar' | abpLocalization }}
      </abp-button>

      <button *ngIf="this.service.selected" class="btn btn-danger" (click)="this.limparCredenciais()">
        {{ 'AbpUi::Limpar Credenciais' | abpLocalization }}
      </button>
    </div>


    <!--<suite-custom-code-block-9>-->
    <!--</suite-custom-code-block-9>-->
